/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSurveyCommandDto
 */
export interface CreateSurveyCommandDto {
    /**
     * Survey name
     * @type {string}
     * @memberof CreateSurveyCommandDto
     */
    name: string;
    /**
     * Survey code
     * @type {string}
     * @memberof CreateSurveyCommandDto
     */
    code: string;
    /**
     * Context ID for the survey
     * @type {string}
     * @memberof CreateSurveyCommandDto
     */
    contextId: string;
    /**
     * Optional branch ID
     * @type {string}
     * @memberof CreateSurveyCommandDto
     */
    branchId?: string | null;
    /**
     * Optional survey description
     * @type {string}
     * @memberof CreateSurveyCommandDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the CreateSurveyCommandDto interface.
 */
export function instanceOfCreateSurveyCommandDto(value: object): value is CreateSurveyCommandDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('contextId' in value) || value['contextId'] === undefined) return false;
    return true;
}

export function CreateSurveyCommandDtoFromJSON(json: any): CreateSurveyCommandDto {
    return CreateSurveyCommandDtoFromJSONTyped(json, false);
}

export function CreateSurveyCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSurveyCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'code': json['code'],
        'contextId': json['contextId'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateSurveyCommandDtoToJSON(json: any): CreateSurveyCommandDto {
    return CreateSurveyCommandDtoToJSONTyped(json, false);
}

export function CreateSurveyCommandDtoToJSONTyped(value?: CreateSurveyCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'contextId': value['contextId'],
        'branchId': value['branchId'],
        'description': value['description'],
    };
}

